import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthGuard, PrepareGuard, PendingChangesGuard } from 'app/core/core.module';
import { OrderSearchComponent } from './order-search/order-search.component';
import { OrderSchedulerComponent } from './order-scheduler/order-scheduler.component';
import { OrderDetailComponent } from './order-detail/order-detail.component';
import { MiscLineDialogComponent } from './misc-line-dialog/misc-line-dialog.component';
import { OrderOptionDialogComponent } from './order-option-dialog/order-option-dialog.component';
import { VinDialogComponent } from './vin-dialog/vin-dialog.component';
import { OrderBuildDetailComponent } from './order-build-detail/order-build-detail.component';
import { OrderHistoryComponent } from './order-history/order-history.component';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { OrderMapComponent } from './order-map/order-map.component';
import { StatusUpdateDialogComponent } from './status-update-dialog/status-update-dialog.component';
import { BuildListComponent } from './build-list/build-list.component';
import { EmailSearchComponent } from './email-search/email-search.component';
import { OrderContactInfoDialogComponent } from './order-contact-info-dialog/order-contact-info-dialog.component';
import { StatusReviewComponent } from './status-review/status-review.component';
import { AchDialogComponent } from './ach-dialog/ach-dialog.component';
import { AllocateDialogComponent } from './allocate-dialog/allocate-dialog.component';
import { OrderShipAddressDialogComponent } from './order-ship-address-dialog/order-ship-address-dialog.component';
import { WarrantyRegistrationsComponent } from './warranty-registrations/warranty-registrations.component';
import { ImportInvoiceLinesDialogComponent } from './import-invoice-lines-dialog/import-invoice-lines-dialog.component';



@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'sales-orders',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'search', pathMatch: 'full' },
                    { path: 'search', component: OrderSearchComponent, data: { title: 'Sales Orders' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'scheduler', component: OrderSchedulerComponent, data: { title: 'Scheduler' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'build-detail', component: OrderBuildDetailComponent, data: { title: 'Build Detail' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'history', component: OrderHistoryComponent, data: { title: 'History' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'build-list', component: BuildListComponent, data: { title: 'Build List' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'email', component: EmailSearchComponent, data: { title: 'Email' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'map', component: OrderMapComponent, data: { title: 'Order Map' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'warranty-registrations', component: WarrantyRegistrationsComponent, data: { title: 'Warranty Registrations' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'warranty/:id', component: OrderDetailComponent, data: { title: 'Warranty Detail' }, canActivate: [AuthGuard, PrepareGuard], canDeactivate: [PendingChangesGuard] },
                    { path: ':id', component: OrderDetailComponent, data: { title: 'Detail' }, canActivate: [AuthGuard, PrepareGuard], canDeactivate: [PendingChangesGuard] },
                ],
            },
        ]),
    ],
    declarations: [
        AchDialogComponent,
        OrderSearchComponent,
        OrderSchedulerComponent,
        OrderDetailComponent,
        MiscLineDialogComponent,
        OrderOptionDialogComponent,
        VinDialogComponent,
        OrderBuildDetailComponent,
        OrderHistoryComponent,
        OrderMapComponent,
        StatusUpdateDialogComponent,
        BuildListComponent,
        EmailSearchComponent,
        OrderContactInfoDialogComponent,
        StatusReviewComponent,
        AllocateDialogComponent,
        OrderShipAddressDialogComponent,
        WarrantyRegistrationsComponent,
        ImportInvoiceLinesDialogComponent
    ]
})
export class OrdersModule {}
